import { motion } from 'framer-motion';

export default function FooterAuth() {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut', delay: 0.3 }}
      className="
        text-xs font-semibold
        text-center md:text-left
        py-4 w-full px-4 md:pl-10
        bg-[#DADDFB]                /* mobile: full purple */
        md:bg-[linear-gradient(to_right,white_0%,white_50%,#DADDFB_50%,#DADDFB_100%)]
      "
    >
      © 2026 uLegal AI
    </motion.footer>
  );
}
